export const GET_PROTOCOLS_TYPES = "GET_PROTOCOLS_TYPES";
export const GET_PROTOCOLS_TYPES_SUCCESS = "GET_PROTOCOLS_TYPES_SUCCESS";
export const GET_PROTOCOLS_TYPES_FAILURE = "GET_PROTOCOLS_TYPES_FAILURE";



export const GET_PROTOCOLS = "GET_PROTOCOLS";
export const GET_PROTOCOLS_SUCCESS = "GET_PROTOCOLS_SUCCESS";
export const GET_PROTOCOLS_FAILURE = "GET_PROTOCOLS_FAILURE";


export const CREATE_PROTOCOLS = "CREATE_PROTOCOLS";
export const CREATE_PROTOCOLS_SUCCESS = "CREATE_PROTOCOLS_SUCCESS";
export const CREATE_PROTOCOLS_FAILURE = "CREATE_PROTOCOLS_FAILURE";

export const UPDATE_PROTOCOLS = "UPDATE_PROTOCOLS";
export const UPDATE_PROTOCOLS_SUCCESS = "UPDATE_PROTOCOLS_SUCCESS";
export const UPDATE_PROTOCOLS_FAILURE = "UPDATE_PROTOCOLS_FAILURE";


export const DELETE_PROTOCOLS_REQUEST = "DELETE_PROTOCOLS_REQUEST";
export const DELETE_PROTOCOLS_SUCCESS = "DELETE_PROTOCOLS_SUCCESS";
export const DELETE_PROTOCOLS_FAILURE = "DELETE_PROTOCOLS_FAILURE";


export const RETRY_PROTOCOL_CONVERSION = "RETRY_PROTOCOL_CONVERSION";
export const RETRY_PROTOCOL_CONVERSION_SUCCESS = "RETRY_PROTOCOL_CONVERSION_SUCCESS";
export const RETRY_PROTOCOL_CONVERSION_FAILURE = "RETRY_PROTOCOL_CONVERSION_FAILURE";